import useAxios from 'axios-hooks';
import { ICompletedSection, IOtherDescription } from './utils';

export interface IFinancialStatements {
  id?: number;
  otherDescriptions?: Array<IOtherDescription> | null;
  completedSection?: ICompletedSection;
}

export interface IOneReportResponse {
  symbol: string | null;
  receiveDate: string | null;
  year: string | null;
  url: string | null;
}

export const useSaveFinancialFile = (
  id?: number,
  payload?: IFinancialStatements
) => {
  return useAxios<IFinancialStatements>(
    {
      method: 'POST',
      url: `financial-statement/${id}`,
      data: payload,
    },
    { manual: true }
  );
};

export const useGetFinancialOtherAndComplete = (id: number) => {
  return useAxios({
    url: `financial-statement/${id}`,
  });
};

export const useGetFinancialFromOneReport = (
  companyId: string,
  year: number,
  lang: string
) => {
  return useAxios<IOneReportResponse>({
    url: 'one-report',
    params: {
      companyId,
      year,
      lang,
    },
  });
};

export const useGetFinancialStatement = (
  companyId: number,
  lang?: string,
  year?: string
) => {
  return useAxios({
    url: `financial-statement/${companyId}/download`,
    params: {
      lang,
      year,
    },
    responseType: 'blob',
  });
};
